/**
 * @function cleanNameInput a pure util function that trims whitespace from
 * text input and sets the state value by invoking @param updateInput
 * @param {String} text the current target value of the input field.
 * @param {React.Dispatch<any>} updateInput updates the state variable
 */
const cleanNameInput = (text, updateInput) => {
  const cleanedInput = text.trim().replace(/^\s+|\s+$/g, "");
  updateInput(cleanedInput);
};

export { cleanNameInput };
